export default {
      id: "facebook-flat-usage",
      viewBox: "0 0 15 26",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#facebook-flat",
      toString: function () {
        return this.url;
      }
    }